import React, { Component } from 'react';
import './AddModal.css';
import {Icon, Modal, Row, Input} from 'react-materialize';

class AddModal extends Component {

	render() {
		return (
     <Modal trigger={<button className='add'><Icon large>add</Icon></button>} header='Adicionar um novo grafico'
        actions={
          <div>
            <button className="cancela waves-effect waves-light btn-flat modal-action modal-close" onClick={this.closeModal}>Cancelar</button>
            <button className="remove waves-effect waves-light btn-flat modal-action modal-close" onClick={()  => this.props.create()}>Criar Grafico</button>
          </div>
        }>

        <div>
          <Row>
            <Input s={12} type='select' label="Escolha o tipo de Grafico" defaultValue='Pizza' onChange={(e) => this.props.type(e.target.value)}>
              <option value='Pizza'>Pizza</option>
              <option value='Barra'>Barra</option>
            </Input>
            

            <Input s={12} type='select' label="Escolha o indicador" defaultValue='IMC' onChange={ (e) => this.props.data(e.target.value)} >
              <option value='IMC'>IMC</option>
              <option value='Peso'>Peso</option>
              <option value='Idade'>Idade</option>
              <option value='Altura'>Altura</option>
            </Input>
          
          </Row>
        </div>
      </Modal>
		)
	}


}

export default AddModal;


// WEBPACK FOOTER //
// ./src/components/AddModal.js